import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDaily, useDevices } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom, cameraInputAtom } from '../../State';
import { getAuth, signOut } from 'firebase/auth';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import AddAccess from '../Util/AddAccess';
import MobileEditName from './MobileEditName';

//アイコン系
import { ReactComponent as LogoutSVG } from '../Images/buttons/settingLogout.svg';
import { ReactComponent as FAQSVG } from '../Images/buttons/settingFAQbutton.svg';
import { ReactComponent as CloseSVG } from '../Images/buttons/windowCloseButton.svg';
import { ReactComponent as MiniSVG } from '../Images/buttons/windowMinimizeButton.svg';
import { ReactComponent as ProfileSVG } from '../Images/buttons/settingProfileButton.svg';
import { ReactComponent as LanguageSVG } from '../Images/buttons/settingLanguageButton.svg';

//MUI系コンポーネント
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import { Button } from '@mui/material';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function MobileSetting({
  showFormState,
  setShowFormState,
  drawerState,
  setDrawerState,
}) {
  const { t, i18n } = useTranslation();
  const [showLanguageState, setShowLanguageState] = useState(false);
  const [authState, setAuthState] = useRecoilState(isAuthAtom);

  const handleClose = () => {
    setShowFormState(false);
  };

  //言語のアップデート
  const updateLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  //ログアウトタップ
  const tapLogout = () => {
    //アクセス
    AddAccess('page-view', 'logout');

    var result = window.confirm(t('setting.Are you sure you want to logout?'));
    if (result) {
      signOut(getAuth()).then(() => {
        setAuthState(false);
        localStorage.removeItem('token');
        localStorage.removeItem('imageURL');
        localStorage.removeItem('displayName');
        localStorage.removeItem('backImageURL');
        localStorage.removeItem('nftID');
        localStorage.removeItem('isAuth');
        localStorage.removeItem('meetingID');
      });

      // setPageState('main');
    }
  };

  const list = (anchor) => (
    <Box
      sx={{ width: 250, marginTop: 'calc(env(safe-area-inset-top))' }}
      role="presentation"
      onClick={setDrawerState}>
      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => {
              setShowFormState(true);

              setTimeout(() => {
                setDrawerState(false);
              }, 100);
            }}>
            <ListItemIcon>
              <ProfileSVG />
            </ListItemIcon>
            <ListItemText primary={t('haircheck.Display Name')} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => {
              setShowLanguageState(true);
              setTimeout(() => {
                setDrawerState(false);
              }, 100);
            }}>
            <ListItemIcon>
              <LanguageSVG />
            </ListItemIcon>
            <ListItemText primary={t('setting.Language')} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <FAQSVG />
            </ListItemIcon>
            <ListItemText primary={t('setting.FAQ')} />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton
            onClick={() => {
              tapLogout();
            }}>
            <ListItemIcon>
              <LogoutSVG />
            </ListItemIcon>
            <ListItemText primary={t('setting.Logout')} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      {/* ドロワー */}
      <Drawer
        anchor={'left'}
        open={drawerState}
        onClose={() => {
          setDrawerState(false);
        }}>
        {list('left')}
      </Drawer>

      {/* 名前編集用のポップアップ */}
      {showFormState && <MobileEditName setShowEditName={setShowFormState} />}
      {/* <Dialog open={showFormState} onClose={handleClose}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label={t('haircheck.Display Name')}
            type="text"
            fullWidth
            variant="standard"
            placeholder={t('haircheck.Type Display Name')}
            InputLabelProps={{ style: { color: 'green' } }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} style={{ textTransform: 'none', color: '#000' }}>
            {t('call.Cancel')}
          </Button>
          <Button
            onClick={handleClose}
            sx={'background-color:black;color:#fff;textTransform:none;'}
            style={{ textTransform: 'none' }}>
            {t('mypage.Save')}
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* 言語編集 */}
      <Dialog
        open={showLanguageState}
        onClose={() => {
          setShowLanguageState(false);
        }}>
        <DialogContent>
          <div id="mobileLanguage">
            <label htmlFor="cameraOptions">{t('setting.Language')}</label>
            <select
              name="languageOptions"
              id="cameraSelect"
              onChange={updateLanguage}
              value={i18n.language}>
              <option key="language1" value="en">
                {t('setting.English')}
              </option>
              <option key="language2" value="ja">
                {t('setting.Japanese')}
              </option>
            </select>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
